import React, { Ref, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useMutation, useQuery } from '../../convex/_generated/react'

import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
  Select,
  Button,
  useDisclosure
} from '@chakra-ui/react'
import { Proposal } from '../../types'
import { Id } from '../../convex/_generated/dataModel'
import { FiPlus } from 'react-icons/fi'
import ProjectFormModal from '../Modals/ProjectFormModal'

interface IProps {
  _id?: Id
  formRef ?: Ref<HTMLFormElement>
  onSuccess?: () => void
}

interface ProposalFormTypes extends Omit<Proposal, '_id' | 'project' | 'estimates'>{
  project: string
}

const ProposalForm: React.FC<IProps> = ({ _id, onSuccess, formRef }) => {
  const currentProposal = useQuery('proposalById', _id || null)
  const projectsList = useQuery('listProjects')
  const { isOpen, onClose, onOpen } = useDisclosure()

  const {
    handleSubmit,
    register,
    formState: { errors },
    reset
  } = useForm<ProposalFormTypes>()

  useEffect(() => {
    reset({
      ...currentProposal,
      project: currentProposal?.project.toString()
    })
  }, [currentProposal, projectsList])

  const createProposal = useMutation('createProposal')
  const updateProposal = useMutation('updateProposal')

  const onSubmit = async (data: ProposalFormTypes) => {
    if (_id) {
      updateProposal({
        ...data,
        project: new Id('projects', data.project),
        _id
      })
      onSuccess && onSuccess()
      return
    }

    await createProposal({
      ...data,
      project: new Id('projects', data.project)
    })
    onSuccess && onSuccess()
  }

  return (
    <form ref={formRef} onSubmit={handleSubmit(onSubmit)}>

      <FormControl>
        <FormLabel>Name</FormLabel>
        <Input {...register('name')} placeholder='Proposal name' />
        <FormErrorMessage>
          {errors.name && errors.name.message}
        </FormErrorMessage>
      </FormControl>

      <FormControl mt={4}>
        <FormLabel>Project</FormLabel>
        <Select {...register('project')} placeholder='Select project'>
          {
            projectsList?.map(
              project =>
                <option
                  key={project._id?.toString()}
                  value={project._id?.toString()}
                >
                  { project.name }
                </option>
            )
          }
        </Select>
      </FormControl>
      <Button onClick={onOpen} gap={2} mt={4}><FiPlus /> New Project</Button>
      <ProjectFormModal
        isOpen={isOpen}
        onClose={onClose}
      />

    </form>
  )
}

export default ProposalForm
